import setupApi from '../libs/Api';
import config from '../config';

export default class Auth {
  static async authUser(key, path) {
    const api = setupApi(config.baseUrl, key, path);
    const res = await api.call('/auth');
    return res.status;
  }
}




// WEBPACK FOOTER //
// ./src/libs/Auth.js